enum ConsumerRoutePath {
  PRODUCT_REPORT_FAULT = '/products/report-fault',
  PRODUCT_SEARCH_REPAIRER = '/products/search-repairer',
  PRODUCT_SCAN = '/products/scan',
  PRODUCT_ENTER_BARCODE = '/products/enter-barcode',
  PRODUCT_SEARCH_CATALOG = '/products/search-catalog',
  PRODUCT_DATABASE_LOOKUP_RESULT = '/products/database-lookup-result',
  PRODUCT_DATABASE_LOOKUP_FAILED = '/products/database-lookup-failed',
  MANUAL_PRODUCT_ENTRY = '/products/manual-entry',
  ADD_ASSIGNED_PRODUCT_DETAILS = '/products/add-assigned-product-details',
  VIEW_PRODUCT_DETAILS = '/products/view-product-details',
  VIEW_ASSIGNED_PRODUCT = '/products/view-assigned-product',
  REPAIR_VIEW_PRODUCT = '/view-product',

  PROFILE = '/profile',
  USER_INFO = '/profile/user-info',
  USER_ADDRESS = '/profile/user-address',

  HELP = '/help',
  REFER = '/refer',
  COMPETITION_TERMS = '/competition-terms',

  WALLET = '/wallet',
  ADD_PAYMENT_METHOD = '/add-payment-method',
  ADD_CARD = '/add-card',
  USER_CARD_DETAILS = '/user-card-details',
  HISTORY = '/history',
}

export default ConsumerRoutePath;
